import styled from "styled-components";
import { getFilledTextColor } from "../Button/helperStyles";

interface PaginationButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  $selected: boolean;
}

const PaginationButton = styled.button<PaginationButtonProps>`
  cursor: pointer;
  border-radius: 2px;
  ${({ $selected, theme }) => {
    const fill = $selected ? theme.buttonPrimary : theme.textMuted;
    return `
      background-color: ${fill};
      color: ${getFilledTextColor(fill, theme)};
    `;
  }}
  width: 20px;
  height: 20px;
  margin-right: 15px;
  margin-bottom: 5px;

  &:hover {
    opacity: 0.8;
  }
`;

export default PaginationButton;
